import { Button, StatusMessage } from '@krp/ui-kit'

import type { ActionView } from './views'

const KIND_TITLES: Record<string, string> = {
  conflict: 'Не выполнено: данные изменились или состояние не позволяет',
  validation: 'Сервер отклонил запрос',
  forbidden: 'Нет доступа к этому действию',
  unauthorized: 'Сессия завершена',
  unavailable: 'Служба недоступна',
  'unknown-outcome': 'Исход неизвестен',
}

/**
 * Отказ команды: причина сервера дословно (ADR-8), код и корреляция — для
 * отчёта. 409 и «исход неизвестен» объяснены словами: повторять вслепую нельзя.
 */
export function ActionError({
  error,
  onReload,
  onRetry,
}: {
  error: ActionView['error']
  onReload?: () => void
  /** Повторить ту же команду: предлагается, когда повтор имеет смысл (не при 409 — там версия устарела, нужно перечитать). */
  onRetry?: () => void
}) {
  if (error === null) return null
  const kind = error.kind === 'unauthorized' ? 'unauthorized' : error.kind === 'forbidden' ? 'forbidden' : error.kind === 'unavailable' ? 'unavailable' : 'error'
  const meta = `Код: ${error.code}${error.correlationId === null ? '' : ` · запрос ${error.correlationId}`}`
  const needsReload = error.kind === 'conflict' || error.kind === 'unknown-outcome'
  return (
    <StatusMessage
      kind={kind}
      title={KIND_TITLES[error.kind] ?? 'Не выполнено'}
      text={error.message}
      meta={meta}
      action={
        needsReload && onReload !== undefined ? (
          <Button onClick={onReload} actionId="common.reread-after-conflict">
            Перечитать
          </Button>
        ) : !needsReload && onRetry !== undefined ? (
          <Button variant="secondary" onClick={onRetry} actionId="common.retry">
            Повторить
          </Button>
        ) : undefined
      }
    />
  )
}
